module.exports = {
  querying: null,
  showHelp: false,
  feedback: {
    show: false,
    search: null,
    feedbackText: '',
    email: ''
  },
  showSidebar: false,
  previewing: null,
  v2viewing: null,
  serverrender: null,
  collection: null,
  view: 'home',
  previewPages: {},
  authToken: null,
  loginView: null,
  paperCropClipboard: null,
  loginInfo: null
}
